import _extends from "@babel/runtime/helpers/extends";
import { Pagination, PaginationItem, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ArrowLeftIconNew } from '../../../assets/images';
import { MuiStack } from '../../../components';
var useStyles = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        marginTop: '10px',
        width: '100%',
        height: '45px',
        paddingBottom: '10px',
        "& .MuiPagination-ul": {
            "& > li:first-child": {
                position: 'absolute',
                left: 0,
                '& .css-1iahh0a-MuiButtonBase-root-MuiPaginationItem-root': {
                    //minWidth:0,
                    height: 'auto',
                    padding: 0,
                    '-webkit-tap-highlight-color': '#C3CCD6'
                }
            },
            "& > li:last-child": {
                position: 'absolute',
                right: 0,
                '& .css-1iahh0a-MuiButtonBase-root-MuiPaginationItem-root': {
                    //minWidth:0,
                    height: 'auto',
                    padding: 0,
                    '-webkit-tap-highlight-color': '#C3CCD6'
                }
            }
        }
    },
    item: {
    // '&.Mui-selected': {
    //   backgroundColor: '#F4F7FA',
    //   color: 'black',
    //   borderColor: '#F4F7FA',
    //   borderRadius: 0,
    // },
    },
    previousNext: {
        color: '#000000',
        border: '1px solid #DEE4EB',
        borderRadius: '5px',
        padding: '10px 15px',
        display: 'flex',
        textDecoration: 'none',
        minWidth: 0
    },
    ellipsis: {
        pointerEvents: 'none'
    },
    disabled: {
        color: '#ccc'
    },
    ulStyle: {}
});
var CustomPagination = function (props) {
    var count = props.count, page = props.page, onPageChange = props.onPageChange;
    var classes = useStyles();
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px"
    }, /*#__PURE__*/ React.createElement(Pagination, {
        className: classes.root,
        count: count,
        page: page,
        onChange: onPageChange,
        shape: "rounded",
        renderItem: function (item) { /*#__PURE__*/ return React.createElement(PaginationItem, _extends({
            id: "pagination-count"
        }, item, {
            component: "div",
            classes: {
                root: classes.item,
                ellipsis: classes.ellipsis,
                disabled: classes.disabled
            },
            components: {
                previous: function () { /*#__PURE__*/ return React.createElement(MuiStack, {
                    flexDirection: "row",
                    className: "".concat(classes.previousNext),
                    sx: {}
                }, /*#__PURE__*/ React.createElement("img", {
                    id: "backArrow",
                    src: ArrowLeftIconNew,
                    alt: "backArrow"
                }), /*#__PURE__*/ React.createElement(Typography, {
                    id: "previous-btn"
                }, " Previous")); },
                next: function () { /*#__PURE__*/ return React.createElement(MuiStack, {
                    flexDirection: "row",
                    className: "".concat(classes.previousNext)
                }, /*#__PURE__*/ React.createElement(Typography, {
                    id: "next-btn"
                }, " Next"), /*#__PURE__*/ React.createElement("img", {
                    id: "nextarrow",
                    src: ArrowLeftIconNew,
                    alt: "backArrow",
                    style: {
                        transform: 'rotate(180deg)'
                    }
                })); }
            }
        }, item)); }
    }));
};
export default CustomPagination;
